import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { History, ChevronDown, ChevronRight, Copy, RefreshCw } from "lucide-react";

const CopyBtns = ({ onOld, onNew, testid, small }) => (
  <span className="inline-flex items-center gap-1 shrink-0">
    <button type="button" onClick={onOld} data-testid={`${testid}-old`} title="Salin dengan harga lama" className={`inline-flex items-center gap-1 rounded border border-slate-300 text-slate-600 hover:border-sky-400 hover:text-sky-600 ${small ? "px-1 py-0.5 text-[10px]" : "px-1.5 py-0.5 text-[10px] font-medium"}`}><Copy className="w-3 h-3" />{small ? "" : " Harga lama"}</button>
    <button type="button" onClick={onNew} data-testid={`${testid}-new`} title="Salin & hitung ulang harga terbaru" className={`inline-flex items-center gap-1 rounded border border-emerald-300 text-emerald-700 hover:bg-emerald-50 ${small ? "px-1 py-0.5 text-[10px]" : "px-1.5 py-0.5 text-[10px] font-medium"}`}><RefreshCw className="w-3 h-3" />{small ? "" : " Harga terbaru"}</button>
  </span>
);

const QuoteRow = ({ q, onCopy }) => {
  const [open, setOpen] = useState(false);
  const lines = (q.quote?.lines || q.lines || []).filter((l) => !l.additional);
  return (
    <div className="border-t border-slate-100 first:border-t-0" data-testid={`cqh-row-${q.code}`}>
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between gap-2 px-3 py-2 text-xs hover:bg-slate-50" data-testid={`cqh-toggle-${q.code}`}>
        <span className="flex items-center gap-1.5 min-w-0">
          {open ? <ChevronDown className="w-3.5 h-3.5 shrink-0" /> : <ChevronRight className="w-3.5 h-3.5 shrink-0" />}
          <span className="font-mono text-slate-700 whitespace-nowrap">{q.code}</span>
          <span className="text-slate-400 hidden sm:inline">{(q.created_at || "").slice(0, 10)}</span>
          <span className="px-1.5 py-0.5 rounded bg-slate-100 text-[10px] text-slate-600">{q.status}</span>
        </span>
        <span className="font-semibold text-slate-800 shrink-0">{formatIDR(q.quote?.total || 0)}</span>
      </button>
      {open && (
        <div className="px-3 pb-2 space-y-1" data-testid={`cqh-lines-${q.code}`}>
          {lines.length > 0 && onCopy && (
            <div className="flex items-center justify-between gap-2 pb-1 text-[10px] text-slate-500">
              <span>Salin semua item ke quotation baru:</span>
              <CopyBtns testid={`cqh-copy-all-${q.code}`} onOld={() => onCopy(lines, false)} onNew={() => onCopy(lines, true)} />
            </div>
          )}
          {lines.length === 0 ? <p className="text-[11px] text-slate-400">Tidak ada item.</p> : lines.map((l, i) => {
            const qty = +l.quantity || 1;
            return (
              <div key={i} className="flex justify-between items-start gap-2 text-[11px] text-slate-600">
                <span className="min-w-0">{i + 1}. {l.name}{+l.weight_g > 0 ? ` · ${l.weight_g}g` : ""} × {qty} <span className="text-slate-400">@ {formatIDR(Math.round((+l.line_total || 0) / qty))}</span></span>
                <span className="flex items-center gap-1.5 shrink-0">
                  <span>{formatIDR(l.line_total || 0)}</span>
                  {onCopy && <CopyBtns small testid={`cqh-copy-${q.code}-${i}`} onOld={() => onCopy([l], false)} onNew={() => onCopy([l], true)} />}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export const CustomerQuoteHistory = ({ customerId, onCopy }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    setRows(null);
    api.get(`/customers/${customerId}`).then(({ data }) => setRows(data.quotations || [])).catch(() => setRows([]));
  }, [customerId]);
  return (
    <div className="border border-slate-200 rounded-xl overflow-hidden" data-testid="customer-quote-history">
      <div className="flex items-center gap-1.5 px-3 py-2 bg-slate-50 text-xs font-semibold text-slate-700"><History className="w-3.5 h-3.5" /> Riwayat Quotation Customer{rows ? ` (${rows.length})` : ""}</div>
      <div className="max-h-56 overflow-y-auto">
        {rows === null ? <p className="px-3 py-2 text-[11px] text-slate-400">Memuat…</p>
          : rows.length === 0 ? <p className="px-3 py-2 text-[11px] text-slate-400" data-testid="cqh-empty">Belum ada quotation sebelumnya.</p>
          : rows.map((q) => <QuoteRow key={q.id} q={q} onCopy={onCopy} />)}
      </div>
    </div>
  );
};
